import React from 'react';
import Scroll from 'react-scroll';
import Select from 'react-select';

import FieldController from '../../controller/FieldController';
import RegEx from '../../util/RegEx';
import Const from '../../util/Constants';

class FieldDocumentType extends React.Component {
  
  constructor(props) {
    super(props);
    this.visible = props.field.visible === Const.True;
    this.editable = props.field.editable === Const.True;
    this.LabelName = props.field.label_name;
    this.regex = props.field.validate;
    this.Key = props.id;
    this.options = FieldController.getOptions(props.field);
    this.options = this.options.filter(item => item.module === props.model_no);
    const value = parseInt(this.props.value);
    const selection = this.options.find(option => parseInt(option.value) === value);
    this.state = { selection: selection, inValid: {} };
  }

  UNSAFE_componentWillReceiveProps(props) {
    const visible = props.field.visible === Const.True;
    const editable = props.field.editable === Const.True;
    
    this.options = FieldController.getOptions(props.field);
    this.options = this.options.filter(item => item.module === props.model_no);
    const value = parseInt(props.value);
    const selection = this.options.find(option => parseInt(option.value) === value);
    
    if(visible !== this.visible || editable !== this.editable) {
      this.visible = props.field.visible === Const.True;
      this.editable = props.field.editable === Const.True;
      this.LabelName = props.field.label_name;
      this.regex = props.field.validate;
      this.Key = props.id;
      this.setState({ ...this.state, selection: selection, inValid: {} });
    }
  }

  onChange = selected => {
    const value = selected === null ? 0 : selected.value;
    let inValid = { };
    if(!RegEx.isDate(value, this.regex)) inValid[this.Key] = 'Invalid Data';
    this.props.onValueChange(this.Key, value);
    this.setState({ selection: selected, inValid: { ...inValid } });
  }

  render() {
    if(!this.visible || !this.editable) return null;
    
    let inValid = this.state.inValid;
    if(this.editable && RegEx.isKeyPresent(this.props.inValid, this.Key)) {
      inValid = this.props.inValid;
    }

    return (
      <div className="col">
        <div className={`form-group ${RegEx.class(inValid, this.Key)}`}>
          <Scroll.Element name={this.Key} />
          <label>{this.LabelName}</label> {RegEx.showError(inValid, this.Key)}
          <Select name={this.Key} value={this.state.selection} onChange={this.onChange}
            options={this.options} isDisabled={!this.editable} isSearchable={true}
            isClearable={true} />
        </div>
      </div>
    );
  }
}
export default FieldDocumentType;